import { render, staticRenderFns } from "./SafetyEquipmentManagerment.vue?vue&type=template&id=70d5383f&scoped=true"
import script from "./SafetyEquipmentManagerment.vue?vue&type=script&lang=js"
export * from "./SafetyEquipmentManagerment.vue?vue&type=script&lang=js"
import style0 from "./SafetyEquipmentManagerment.vue?vue&type=style&index=0&id=70d5383f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d5383f",
  null
  
)

export default component.exports